export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {}
  },
  actions: {
    /**
     * @description 设置客户数据
     * @param {Object} context
     * @param {*} info info
     */
    async set ({ state, dispatch }, info) {
      console.log(info,'infoinfoinfo')
      // store 赋值
      state.info = info
      // 持久化
      await dispatch('tccc/db/set', {
        dbName: 'sys',
        path: 'client.info',
        value: info,
        user: true
      }, { root: true })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    async load ({ state, dispatch }) {
      let info = await dispatch('tccc/db/get', {
        dbName: 'sys',
        path: 'client.info',
        defaultValue: {},
        user: true
      }, { root: true })
      // store 赋值
      state.info = info
    }
  }
}
